import type { FC, SVGProps } from "react";

const IconSearch: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 12.9998L10.1067 10.1064" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.33333 11.6667C9.27885 11.6667 11.6667 9.27885 11.6667 6.33333C11.6667 3.38781 9.27885 1 6.33333 1C3.38781 1 1 3.38781 1 6.33333C1 9.27885 3.38781 11.6667 6.33333 11.6667Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconSearch;
